/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_VenueInputs */

const cs_col_venue = /** @type {(inputs: Col_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pobočka`)
};

const en_col_venue = /** @type {(inputs: Col_VenueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venue`)
};

/**
* | output |
* | --- |
* | "Venue" |
*
* @param {Col_VenueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_venue = /** @type {((inputs?: Col_VenueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_VenueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_venue(inputs)
	return cs_col_venue(inputs)
});